import React from "react";
import "./CarrierDetailsComp.css";
import checkCircle from "../../images/check-circle.png";

const CarrierDetailsComp = () => {
  return (
    <div
      className="troo-da-carrer-detail-section"
      id="troo-da-carrer-detail-section"
    >
      <div className="container">
        <div className="row">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-12">
                <h4>Yoga Teacher</h4>
                <p>Posted by: Admin / Location: London School</p>
                <h4>Overview</h4>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. what is Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an
                  unknown printer took a galley is of type and scrambled it to
                  make a type specimen book. It has survived not only five
                  centuries, but also the leap into is this electronic
                  typesetting, remaining essentially unchanged. It was
                  popularised in the 1960s with the release of Letrasetis this
                  sheets containing Lorem Ipsum passages, and more recently with
                  Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. what is Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an
                  unknown printer took a galley is of type and scrambled it to
                  make a type specimen book.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="deail-lit">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. what is Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an
                    unknown printer took a galley is of type and scrambled it to
                    make a type specimen book. It has survived not only five
                    centuries, but also the leap.
                  </p>
                  <h4>Responsabilities</h4>
                  <div className="row">
                    <div className="col-md-6">
                      <ul>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Emergency response time is one hour</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>We want you to pletely satisfied</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>
                            You deserve to have your in plain English.{" "}
                          </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Our service philosophy </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Emergency response time</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>We want you to be completely </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>
                            Your questions answered in plain English.{" "}
                          </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Our service philosophy is proactive.</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h4>Requirements</h4>
                  <div className="row">
                    <div className="col-md-6">
                      <ul>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Emergency response time is one hour</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>We want you to pletely satisfied</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>
                            You deserve to have your in plain English.{" "}
                          </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Our service philosophy </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Emergency response time</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>We want you to be completely </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>
                            Your questions answered in plain English.{" "}
                          </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Our service philosophy is proactive.</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h4>Skills</h4>
                  <div className="row">
                    <div className="col-md-6">
                      <ul>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Emergency response time is one hour</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>We want you to pletely satisfied</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>
                            You deserve to have your in plain English.{" "}
                          </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Our service philosophy </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Emergency response time</span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>We want you to be completely </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>
                            Your questions answered in plain English.{" "}
                          </span>
                        </li>
                        <li>
                          <img src={checkCircle} alt="checkCircle" />
                          <span>Our service philosophy is proactive.</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="sidebar">
              <div className="course-features">
                <h4>Information</h4>
                <ul>
                  <li>
                    <strong>Experience : </strong>
                    <span>Min 1 year</span>
                  </li>
                  <li>
                    <strong> Work Level : </strong>
                    <span> Entry-Level</span>
                  </li>
                  <li>
                    {" "}
                    <strong>Employment Type : </strong> <span>Full time </span>
                  </li>
                  <li>
                    <strong>Salary : </strong> <span> 10k - 15k / year</span>
                  </li>
                  <li>
                    {" "}
                    <strong>Phone : </strong>
                    <span> +44 123 456 7890 </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrierDetailsComp;
